import { Box } from 'components/Box';
import styled from 'styled-components';
import { border } from 'styled-system';

const Card = styled(Box)`
  position: relative;
  border-radius: 10px;

  background-color: var(--paper);
  color: var(--primary-text);

  border: 1px solid var(--card-border);

  ${border}

  &.disabled::after {
    content: ' ';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    border-radius: 10px;
    background-color: #dadada87;
  }
`;

Card.defaultProps = {
  padding: '16px',
};

export { Card };
